import { useQuery } from '@tanstack/react-query';
import { actionLogService } from '@/services/api/action-log.service';
import type { ActionLogFilters } from '@/types';
import { queryKeys } from './keys';

/** The estate-wide action log, one page at a time, narrowed by `filters`. */
export function useActionLog(filters: ActionLogFilters, offset: number, limit: number) {
  return useQuery({
    queryKey: queryKeys.actionLog.list(filters, offset),
    queryFn: ({ signal }) => actionLogService.list({ ...filters, limit, offset }, signal),
    placeholderData: (previous) => previous,
    staleTime: 30_000,
  });
}

/** The admins who appear in the log, for the actor filter. Changes rarely -
 *  only when somebody acts for the first time. */
export function useActionLogActors() {
  return useQuery({
    queryKey: queryKeys.actionLog.actors(),
    queryFn: ({ signal }) => actionLogService.actors(signal),
    staleTime: 5 * 60_000,
  });
}
